import React, { ChangeEvent } from 'react';
import Recaptcha from 'react-gcaptcha';
import { EventOrValueHandler, WrappedFieldProps } from 'redux-form';

import styles from './style.css';

interface CaptchaProps extends WrappedFieldProps {}

interface CaptchaState {
  readonly onChange: EventOrValueHandler<ChangeEvent>;
  readonly value: any;
}

export default class Captcha extends React.Component<
  CaptchaProps,
  CaptchaState
> {
  constructor(props: CaptchaProps) {
    super(props);
    const { input } = this.props;
    const { onChange, value } = input;

    this.state = {
      onChange,
      value,
    };
  }

  callback(key) {
    this.setState({ value: key });
    this.state.onChange(key);
  }

  captchaExpired = () => {
    this.setState({ value: null });
    this.state.onChange(null);
  };

  render() {
    const { input, meta } = this.props;
    const { touched, error } = meta;

    return (
      <div>
        <Recaptcha
          {...input}
          clsName={`${styles.captcha}`}
          sitekey={process.env.CAPTCHA_PUBLIC_KEY}
          expiredCallback={this.captchaExpired}
          verifyCallback={this.callback.bind(this)}
        />
        <small className={styles.error}>{touched ? error : ''}</small>
      </div>
    );
  }
}
